import {I18n} from 'react-redux-i18n';

class ReportType {

  get name() { }

  isSummaryReport() {
    return false;
  }

  isSummaryByDriver() {
    return false;
  }

  isSummaryDriverDetail() {
    return false;
  }

  isAdminReport() {
    return false;
  }

}

export class SummaryReport extends ReportType {

  get key() {
    return 'SUMMARY_REPORT';
  }

  get name() {
    return I18n.t('page.reports.types.videoSummaryReport');
  }

  isSummaryReport() {
    return true;
  }

}

export class SummaryByDriverReport extends ReportType {

  get key() {
    return 'SUMMARY_BY_DRIVER_REPORT';
  }

  get name() {
    return I18n.t('page.reports.types.videoSummaryByDriver');
  }

  isSummaryByDriver() {
    return true;
  }

}

export class SummaryDriverDetailReport extends ReportType {

  get key() {
    return 'SUMMARY_DRIVER_DETAIL_REPORT';
  }

  get name() {
    return I18n.t('page.reports.types.videoSummaryDriverDetail');
  }

  isSummaryDriverDetail() {
    return true;
  }

}

export class AdminReport extends ReportType {

  get key() {
    return 'ADMIN_REPORT';
  }

  get name() {
    return I18n.t('page.reports.types.adminReport');
  }

  isAdminReport() {
    return true;
  }

}

export const SUMMARY_REPORT = new SummaryReport();
export const SUMMARY_BY_DRIVER_REPORT = new SummaryByDriverReport();
export const SUMMARY_DRIVER_DETAIL_REPORT = new SummaryDriverDetailReport();
export const ADMIN_REPORT = new AdminReport();

export default class ReportTypes {

  static get SUMMARY_REPORT() {
    return SUMMARY_REPORT;
  }

  static get SUMMARY_BY_DRIVER_REPORT() {
    return SUMMARY_BY_DRIVER_REPORT;
  }

  static get SUMMARY_DRIVER_DETAIL_REPORT() {
    return SUMMARY_DRIVER_DETAIL_REPORT;
  }

  static get ADMIN_REPORT() {
    return ADMIN_REPORT;
  }

  static availableReports() {
    return [
      SUMMARY_REPORT,
      SUMMARY_BY_DRIVER_REPORT,
      SUMMARY_DRIVER_DETAIL_REPORT,
      ADMIN_REPORT
    ];
  }

  static selectableReports() {
    const system = localStorage.getItem('systemId');
    if(system === 'geotab'){
      return [
        SUMMARY_REPORT
      ];
    }else{
      return [
        SUMMARY_REPORT,
        SUMMARY_BY_DRIVER_REPORT,
        SUMMARY_DRIVER_DETAIL_REPORT
      ];
    }
  }

  static get(reportTypeKey) {
    return ReportTypes
      .availableReports()
      .find(reportType => reportType.key === reportTypeKey);
  }

}
